import { SnRouteConfig } from '@lib/state/router';
import { SnAvatarConfig } from '@lib/ui/avatar';
import { SnBadgeConfig } from '@lib/ui/badge';
import { SnIconConfig } from '@lib/ui/icon';
import { SnMenuConfig } from '@lib/ui/menu';
import { SnTooltipConfig } from '@lib/ui/tooltip';

import { SnListItemClickHandler } from './list-item-click-handler.type';
import { SnListItemDisableExpression } from './list-item-disable-expression.type';
import { SnListItemHideExpression } from './list-item-hide-expression.type';

interface ISnItemConfig<D> {
  label: string | (() => string);
  secondaryLabel?: string | (() => string);
  badge?: SnBadgeConfig;
  icon?: SnIconConfig;
  route?: SnRouteConfig;
  avatar?: SnAvatarConfig;
  tooltip?: SnTooltipConfig;
  menu?: SnMenuConfig;
  click?: SnListItemClickHandler;
  hidden?: boolean | SnListItemHideExpression;
  disabled?: boolean | SnListItemDisableExpression;
  data?: D;
}

export type SnListItemConfig<D = any> = string | ISnItemConfig<D>;
